import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const location = useLocation();

  useEffect(() => {
    setIsSuperAdmin(localStorage.getItem("is_super_admin") === "true");
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 992;
      setIsDesktop(desktop);

      if (!desktop) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsOpen]);

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    if (!isDesktop) {
      setIsOpen(false);
    }
  };

  const getLinkClass = ({ isActive }) =>
    isActive ? "sidebar-link active" : "sidebar-link";

  return (
    <>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {!isDesktop && isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <h2>Depot Air Cerdas</h2>

        <ul>
          {isSuperAdmin ? (
            <>
              <li>
                <NavLink to="/admin/register" className={getLinkClass} onClick={handleLinkClick}>
                  Registrasi Admin
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/tables" className={getLinkClass} onClick={handleLinkClick}>
                  Kelola Data Master
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/webgis" className={getLinkClass} onClick={handleLinkClick}>
                  WebGIS Depots
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/manage-accounts"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Manajemen Akun
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/smart-weather"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Smart Weather
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/smart-farming"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Smart Farming
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/gps-tracker"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  GPS Tracker
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/water-usage"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Laporan Penggunaan Air
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/water-usage-comparison"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Perbandingan Penggunaan Air
                </NavLink>
              </li>
            </>
          ) : (
            <>
              <li>
                <NavLink to="/dashboard" end className={getLinkClass} onClick={handleLinkClick}>
                  Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/pos" className={getLinkClass} onClick={handleLinkClick}>
                  Kasir (POS)
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/dashboard/pendapatan"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Total Pendapatan
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/dashboard/trek-motor"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Trek Motor & Lokasi Depot
                </NavLink>
              </li>
              <li>
                <NavLink to="/dashboard/cctv" className={getLinkClass} onClick={handleLinkClick}>
                  CCTV (Under Construction)
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/dashboard/profile"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Profil
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/dashboard/pdam-bill"
                  className={getLinkClass}
                  onClick={handleLinkClick}
                >
                  Perhitungan Tagihan PDAM
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;